<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Escalas</v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <ScalesList />
    </v-card-text>
  </v-card>
</template>

<script>
import ScalesList from './components/ScalesList.vue'
export default {
  name: 'ScalesAdmin',
  components: {
    ScalesList,
  },
  data: function () {
    return {
      dialog: false,
    }
  },
  computed: {},
  methods: {},
}
</script>
